import { render, staticRenderFns } from "./CamaraView.vue?vue&type=template&id=6c8cd1ef&scoped=true"
import script from "./CamaraView.vue?vue&type=script&lang=js"
export * from "./CamaraView.vue?vue&type=script&lang=js"
import style0 from "./CamaraView.vue?vue&type=style&index=0&id=6c8cd1ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8cd1ef",
  null
  
)

export default component.exports